// extracted by mini-css-extract-plugin
module.exports = {"dashboardBox":"_3x4NqX5gS50qZgx3Q2Ywi0","title":"_22z8VmyunZAMlCFnE9L8ux"};